module.exports = __webpack_public_path__ + "static/img/play-white-small.53cc57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play-white-small.png
// module id = q7GX
// module chunks = 1